import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { InfraService } from './infra.service';

@Injectable()
export class ScenarioDetectionService {
  private configUrl: string = '';

  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.PythonURL + 'ScenarioDetection';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
    //if (localStorage.getItem('selectedregion') == '1') {
    //  this.configUrl = environment.pythonAPIUrl + 'ScenarioDetection';
    //}
    //else {
    //  this.configUrl = environment.pythonAPIUrlRow + 'ScenarioDetection';
    //}
    }

  public detectScenario(engagementId: number) {
    return this.http.get(`${this.configUrl}?engagementid=${engagementId}`);
        // .catch(this.handleError);
   }

    private handleError(error: Response) {
      return throwError(()=> error);
    }
}
